/**
 * Column config cho dashboard "Cashflows Forecast" — decode 1:1 từ layout PBI
 * (page "Cashflows Forecast", `PBI_ERP.pbix`): label cột lấy đúng displayName
 * của từng visual. Data rows đến từ `GET /dashboard/cashflows`
 * (`store/api/dashboardCashflowsApi.ts`); format số dùng chung PnLTable.
 */
import type { PnLColumn } from '../pnl/PnLTable'

/** I. FX table: Bank | Buy (Transfer) | Sell (Transfer). */
export const fxColumns: PnLColumn[] = [
  { key: 'bank', label: 'Bank', text: true },
  { key: 'buyTransfer', label: 'Buy (Transfer)' },
  { key: 'sellTransfer', label: 'Sell (Transfer)' },
]

/** I. Market price (LRC): symbol | Last | Change (PBI để trống header cột 1).
 *  Change KHÔNG dùng `signed` — số âm phải ra ngoặc đỏ `(40)` đồng nhất mọi
 *  bảng của page (chị Đẹp 2026-06-10). */
export const marketColumns: PnLColumn[] = [
  { key: 'symbol', label: '', text: true },
  { key: 'last', label: 'Last' },
  { key: 'change', label: 'Change' },
]

/** II. Cash at banks: (name) | VND | USD. */
export const cashColumns: PnLColumn[] = [
  { key: 'name', label: '', text: true },
  { key: 'vnd', label: 'VND' },
  { key: 'usd', label: 'USD' },
]

/** II. Credit facilities: Bank | Limit | Drawn | Room. */
export const creditColumns: PnLColumn[] = [
  { key: 'bank', label: 'Bank', text: true },
  { key: 'limit', label: 'Limit' },
  { key: 'drawn', label: 'Drawn' },
  { key: 'room', label: 'Room' },
]

/** II. USD exposure: (name) | USD — label thụt cấp giữ leading spaces. */
export const exposureColumns: PnLColumn[] = [
  { key: 'name', label: '', text: true, pre: true },
  { key: 'usd', label: 'USD' },
]
